export default "__VITE_ASSET__C2WDsT3U__"